import React from "react"
import { Helmet } from "react-helmet"

const ThirdParty = () => (
  <>
    <Helmet>
      {/* TODO: Create data layer */}
      <script>{`
        window.dataLayer = window.dataLayer || [];
      `}</script>

      {/* Set user email from _ke query param */}
      <script>{`
        window._keKey = '_ke';
        window._keRegex = new RegExp( '[?&]' + window._keKey + '=([^&#]*)', 'i' );
        window._keUrl = decodeURIComponent(window.location.href);
        window._keValue = window._keRegex.exec(window._keUrl);
        if (window._keValue) {
          const _keSplit = _ke.split('=')[0];
          const _keDecoded = atob(_keSplit);
          const _keParsed = JSON.parse(_keDecoded);
          window._keEmail = _keParsed.kl_email;
        }
      `}</script>

      {/* LivePerson */}
      <script async>{`
        window.lpTag=window.lpTag||{},"undefined"==typeof window.lpTag._tagCount?(window.lpTag={site:'7481882'||"",section:lpTag.section||"",tagletSection:lpTag.tagletSection||null,autoStart:lpTag.autoStart!==!1,ovr:lpTag.ovr||{},_v:"1.8.0",_tagCount:1,protocol:"https:",events:{bind:function(t,e,i){lpTag.defer(function(){lpTag.events.bind(t,e,i)},0)},trigger:function(t,e,i){lpTag.defer(function(){lpTag.events.trigger(t,e,i)},1)}},defer:function(t,e){0==e?(this._defB=this._defB||[],this._defB.push(t)):1==e?(this._defT=this._defT||[],this._defT.push(t)):(this._defL=this._defL||[],this._defL.push(t))},load:function(t,e,i){var n=this;setTimeout(function(){n._load(t,e,i)},0)},_load:function(t,e,i){var n=t;t||(n=this.protocol+"//"+(this.ovr&&this.ovr.domain?this.ovr.domain:"lptag.liveperson.net")+"/tag/tag.js?site="+this.site);var a=document.createElement("script");a.setAttribute("charset",e?e:"UTF-8"),i&&a.setAttribute("id",i),a.setAttribute("src",n),document.getElementsByTagName("head").item(0).appendChild(a)},init:function(){this._timing=this._timing||{},this._timing.start=(new Date).getTime();var t=this;window.attachEvent?window.attachEvent("onload",function(){t._domReady("domReady")}):(window.addEventListener("DOMContentLoaded",function(){t._domReady("contReady")},!1),window.addEventListener("load",function(){t._domReady("domReady")},!1)),"undefined"==typeof window._lptStop&&this.load()},start:function(){this.autoStart=!0},_domReady:function(t){this.isDom||(this.isDom=!0,this.events.trigger("LPT","DOM_READY",{t:t})),this._timing[t]=(new Date).getTime()},vars:lpTag.vars||[],dbs:lpTag.dbs||[],ctn:lpTag.ctn||[],sdes:lpTag.sdes||[],hooks:lpTag.hooks||[],ev:lpTag.ev||[]},lpTag.init()):window.lpTag._tagCount+=1;
          `}</script>

      {/* Custora */}
      <script>{`
        window.custoraTrack=window.custoraTrack||[],custoraTrack.load=function(t,a){var r,c,o;window.custoraTrack.appid=t,window.custoraTrack.config=a,r=document.createElement("script"),r.type="text/javascript",r.async=!0,r.src=("https:"===document.location.protocol?"https:":"http:")+"//track.custora.com/pixel.js",c=document.getElementsByTagName("script")[0],c.parentNode.insertBefore(r,c),o=function(t){return function(){custoraTrack.push([t].concat(Array.prototype.slice.call(arguments,0)))}},custoraTrack.track=o("track"),custoraTrack.identify=o("identify"),custoraTrack.addToCart =o("addToCart"),custoraTrack.productView=o("productView"),custoraTrack.searchView=o("searchView"),custoraTrack.addToWishList=o("addToWishList"),custoraTrack.createAccount=o ("createAccount")},custoraTrack.load("14f8c97e83aeb68");
        if (window._keEmail) custoraTrack.identify(window._keEmail, '');
      `}</script>

      {/* BounceX */}
      <script>{`
        (function(d) {
          var e = d.createElement('script');
          e.src = d.location.protocol + '//tag.bounceexchange.com/3888/i.js';
          e.async = true;
          d.getElementsByTagName("head")[0].appendChild(e);
        }(document));
      `}</script>

      {/* Heap */}
      <script>{`
        if (window.hasOwnProperty('heap') && window._keEmail) heap.identify(window._keEmail);
      `}</script>

      {/* Klaviyo */}
      <script>{`
        var _learnq = _learnq || [];
        _learnq.push(['account', 'cfVfSd']);
        if (window._keEmail) _learnq.push(['identify', {'$email' : window._keEmail}]);
        (function() {
          var b = document.createElement('script'); b.type = 'text/javascript'; b.async = true;
          b.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'a.klaviyo.com/media/js/analytics/analytics.js';
          var a = document.getElementsByTagName('script')[0]; a.parentNode.insertBefore(b, a);
        })();
      `}</script>

      {/* Criteo */}
      <script src="//static.criteo.net/js/ld/ld.js" async />
      <script>{`
        var site_type = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q = window.criteo_q || [];
        window.criteo_q.push(
          { event: "setAccount", account: 36635 },
          { event: "setSiteType", type: site_type}
        );
      `}</script>

      {/* PebblePost */}
      <script>{`
        window._pp = window._pp || [];
        _pp.siteId = 1548;
        // _pp.siteUId = "{{ customer.id }}";
        _pp.email = window._keEmail;
        (function() {
          var ppjs = document.createElement('script');
          ppjs.type = 'text/javascript';
          ppjs.async = true;
          ppjs.src = ('https:' == document.location.protocol ? 'https:' : 'http:') +
          '//cdn.pbbl.co/r/' + _pp.siteId + '.js';
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(ppjs, s);
        })();
      `}</script>
    </Helmet>
  </>
)

export default ThirdParty
